import { useNavigate } from 'react-router-dom';
import { useTenantContext } from '@/auth/TenantContext';

/**
 * Lets the user switch the active workspace. Selecting a workspace navigates to
 * its slug prefix (spec 0013, ADR-0003); `WorkspaceLayout` then sets it active
 * so the `X-Tenant-Id` header and per-tenant query keys follow the URL.
 */
export function TenantSwitcher() {
  const { tenants, activeTenantId } = useTenantContext();
  const navigate = useNavigate();

  if (tenants.length === 0) {
    return null;
  }

  if (tenants.length === 1) {
    return (
      <div className="text-sm">
        <span className="text-gray-500">Workspace</span>{' '}
        <span className="font-medium text-gray-800">{tenants[0].name}</span>
      </div>
    );
  }

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-gray-500">Workspace</span>
      <select
        value={activeTenantId ?? ''}
        onChange={(e) => {
          const next = tenants.find((t) => t.id === e.target.value);
          if (next) navigate(`/${next.slug}`);
        }}
        data-testid="tenant-switcher"
        className="cursor-pointer rounded-md border border-gray-300 bg-white px-2 py-1 text-base font-medium text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 [@media(pointer:coarse)]:min-h-[2.75rem] sm:text-sm"
      >
        {tenants.map((tenant) => (
          <option key={tenant.id} value={tenant.id}>
            {tenant.name}
          </option>
        ))}
      </select>
    </label>
  );
}
